module.exports = __webpack_public_path__ + "static/media/icon_close_img_preview.e3a30f20.svg";